import BaseScene from "@Scenes/BaseScene";

/**
 * Create Button Options
 * These are the options for createButton
 */
type CreateButtonOptions = {
    name: string;
    sprite: string;
    x: number;
    y: number;
    scale: number;
    onDown?: () => void;
    onUp?: () => void;
}

/**
 * Controls Scene
 * Handles creation of controls gui
 */
class ControlsScene extends BaseScene
{
    /**
     * Contructor
     * @param name - key name of the scene
     */
    constructor(name: string)
    {
        super(name);
    }

    /**
     * Enables input
     */
    protected enableInput()
    {
        this.input.addPointer(2);
        this.input.on('pointerdown', this.onPointerDown.bind(this));
        this.input.on('pointerup', this.onPointerUp.bind(this));
        this.input.on('pointerout', this.onPointerUp.bind(this));
    }

    /**
     * Creates a button with corresponding callbacks
     * @param name
     * @param x
     * @param y
     */
    protected createButton(options: CreateButtonOptions)
    {
        const defaultFrame = options.name;
        const hoverFrame = defaultFrame + '-hover';

        const button = this.add.sprite(options.x, options.y, options.sprite, defaultFrame);

        button.setScale(options.scale)
        button.setDataEnabled();
        button.data.set('default_frame', defaultFrame);
        button.data.set('hover_frame', hoverFrame);

        if (options.onDown)
        {
            button.data.set('on_down', options.onDown);
        }

        if (options.onDown)
        {
            button.data.set('on_up', options.onUp);
        }

        button.setInteractive();
    }

    /**
     * Callback for pointer down
     * @param pointer
     * @param gameObjects
     */
    protected onPointerDown(pointer: Phaser.Input.Pointer, gameObjects: Phaser.GameObjects.GameObject[])
    {
        if (gameObjects.length > 0)
        {
            const button = gameObjects[0] as Phaser.GameObjects.Sprite;
            const hoverFrame = button.data.get('hover_frame');
            button.setFrame(hoverFrame);

            const callback = button.data.get('on_down');
            if (typeof callback === 'function')
            {
                callback();
            }
        }
    }

    /**
     * Callback for pointer up
     * @param pointer
     * @param gameObjects
     */
    protected onPointerUp(pointer: Phaser.Input.Pointer, gameObjects: Phaser.GameObjects.GameObject[])
    {
        if (gameObjects.length > 0)
        {
            const button = gameObjects[0] as Phaser.GameObjects.Sprite;
            const defaultFrame = button.data.get('default_frame');
            button.setFrame(defaultFrame);

            const callback = button.data.get('on_up');
            if (typeof callback === 'function')
            {
                callback();
            }
        }
    }

}

export default ControlsScene;